import { useTranslation } from '@lyearn/i18n';
import { SparkleOutline } from '@lyearn/icons';
import { Box, Typography } from '@lyearn/ui';
import UserEntity from '@/entity/User';
import { useUserHierarchyQuery } from '@/modules/auth/graphql/queries/generated/userHierarchy';
import { useUserContext } from '@/modules/auth/hooks/useUser';

const SidebarVisibilityDetails = ({ selectedUserId }: { selectedUserId: string }) => {
  const { t } = useTranslation();
  const currentUser = useUserContext();
  const [{ data: selectedUserData }] = useUserHierarchyQuery({
    variables: {
      userId: selectedUserId,
    },
  });

  const [{ data: currentUserData }] = useUserHierarchyQuery({
    variables: {
      userId: currentUser.id,
    },
  });

  const hierarchyPathOfSelectedUser = selectedUserData?.user?.hierarchyPath;
  const hierarchyPathOfCurrentUser = currentUserData?.user?.hierarchyPath;

  const snapShotUser = hierarchyPathOfSelectedUser?.includes(currentUser.id)
    ? selectedUserData?.user
    : hierarchyPathOfCurrentUser?.includes(selectedUserId)
    ? currentUserData?.user
    : null;

  if (!snapShotUser) return null;

  const firstName = UserEntity.firstName(snapShotUser);

  return (
    <Box className="mt-8 flex flex-row items-center rounded-8 bg-bg-secondary px-12 py-8">
      <SparkleOutline className="h-16 w-16 me-8" fillColorToken="icon-active" />
      <Typography color="text-text-paragraph" variant="body-long-02">
        {snapShotUser.id === currentUser.id
          ? t('1on1s:Modal.YourSidebar')
          : t('1on1s:Modal.TheirSidebar', { name: firstName })}
      </Typography>
    </Box>
  );
};

export default SidebarVisibilityDetails;
